import React from "react";

const TotalCount = ({ filters, actualNoOfRows, count }) => {
  const currentPageRows = Math.min(actualNoOfRows, filters.get("limit"));
  return <p style={{ fontSize: "13px" }}>Showing: {`${currentPageRows} / ${count}`}</p>;
};

export default TotalCount;
